import { Box, Typography } from '@mui/material';
import {
  formatQuotationChangeLogLine,
  parseQuotationChangeLogs,
  quotationChangeLogMetaSource,
} from './formatQuotationChangeLogs';

export type ChangeLogCellProps = {
  change_logs: unknown;
  /** Ringkas untuk baris yang belum di-expand. */
  compact?: boolean;
  maxPreviewLines?: number;
};

/** Sel grid: label + nilai lama → baru (bukan JSON mentah). */
export function ChangeLogCell({ change_logs, compact = false, maxPreviewLines = 1 }: ChangeLogCellProps) {
  const entries = parseQuotationChangeLogs(change_logs);
  const meta = quotationChangeLogMetaSource(change_logs);
  const preview = compact ? entries.slice(0, maxPreviewLines) : entries;
  const hiddenCount = compact ? Math.max(0, entries.length - preview.length) : 0;

  if (entries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 0.5, whiteSpace: 'pre-wrap' }}>
        {meta ?? '—'}
      </Typography>
    );
  }

  return (
    <Box sx={{ py: 0.5 }}>
      {meta && !compact ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.25 }}>
          {meta}
        </Typography>
      ) : null}
      {preview.map((e) => (
        <Typography
          key={e.field}
          variant="body2"
          sx={{
            lineHeight: 1.45,
            overflow: compact ? 'hidden' : undefined,
            textOverflow: compact ? 'ellipsis' : undefined,
            whiteSpace: compact ? 'nowrap' : 'normal',
          }}
          data-testid={`quotation-log-change-${e.field}`}
        >
          {formatQuotationChangeLogLine(e)}
        </Typography>
      ))}
      {hiddenCount > 0 ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: 'block' }}>
          +{hiddenCount} perubahan lainnya — klik expand untuk detail
        </Typography>
      ) : null}
    </Box>
  );
}
